import StepConnector, {
	StepConnectorProps,
	stepConnectorClasses,
} from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";

interface BftStepperConnectorProps extends StepConnectorProps {
	orientation: "horizontal" | "vertical";
}

export const BftStepperConnector: React.FC<BftStepperConnectorProps> = styled(
	StepConnector
)<BftStepperConnectorProps>(({ orientation }) => ({
	[`&.${stepConnectorClasses.active}`]: {
		[`& .${stepConnectorClasses.line}`]: {
			borderColor: "white",
		},
	},
	[`&.${stepConnectorClasses.completed}`]: {
		[`& .${stepConnectorClasses.line}`]: {
			borderColor: "#0077fc",
		},
	},
	[`& .${stepConnectorClasses.line}`]: {
		borderColor: "#374052",
		borderTopWidth: 3,
		borderRadius: 1,
		marginLeft: -7,
		minHeight: orientation === "vertical" ? 18 : 0,
	},
}));

export const BftStepperStepIconRoot = styled("div")<{
	ownerState: { active?: boolean };
}>(({ ownerState }: any) => ({
	color: "#ffffff",
	display: "flex",
	height: 0,
	alignItems: "center",
	paddingRight: 4,
	...(ownerState.active && {
		color: "#ffffff",
	}),
	"& .BftStepperStepIcon-completedIcon": {
		width: 10,
		height: 10,
		borderRadius: "50%",
		backgroundColor: "#0077fc",
		border: "1px solid #0077fc",
	},
	"& .BftStepperStepIcon-activeIcon": {
		width: 10,
		height: 10,
		borderRadius: "50%",
		backgroundColor: "#ffffff",
	},
	"& .BftStepperStepIcon-todoIcon": {
		width: 10,
		height: 10,
		borderRadius: "50%",
		backgroundColor: "#192741",
		border: "1px solid #0077fc",
	},
}));
